var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "list-item" }, [
    _c(
      "a",
      {
        staticClass: "list-item__container",
        class: _vm.notificationClass,
        attrs: {
          href: "#drawer-messages-chat",
          "data-toggle": "drawer",
          "aria-foldedopen": "false",
          "aria-controls": "drawer-messages-chat",
        },
        on: { click: _vm.handleGetThreadCallback },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "list-item__participants participants-container flex-shrink-0 m-r-xs",
          },
          _vm._l(_vm.participantsAvatars, function (p) {
            return _c("img", {
              key: p.id,
              attrs: { src: p.avatar, alt: p.name },
            })
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "list-item__content" },
          [
            _c("div", { staticClass: "list-item__header" }, [
              _c("h3", { staticClass: "list-item__title" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.booking.name) + "\n        "
                ),
              ]),
              _vm._v(" "),
              this.thread.unread_count && _vm.$userIsAdmin
                ? _c("span", { staticClass: "list-item__bids" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(this.thread.unread_count) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("meta-item", { attrs: { label: false, "full-width": true } }, [
              _vm._v("\n        " + _vm._s(_vm.participantsNames) + "\n      "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "list-item__status spacer-y-2" }, [
              _vm.bookingIsContextuallyCancelled
                ? _c("span", { staticClass: "label label-danger" }, [
                    _vm._v("Cancelled"),
                  ])
                : _vm.bookingIsScheduled
                ? _c("span", { staticClass: "label label-success" }, [
                    _vm._v("Scheduled"),
                  ])
                : _vm.bookingIsOnHold
                ? _c("span", { staticClass: "label label-info" }, [
                    _vm._v("On Hold"),
                  ])
                : _vm.bookingIsBooked
                ? _c("span", { staticClass: "label label-success" }, [
                    _vm._v("Booked"),
                  ])
                : _vm.bookingIsCompleted
                ? _c("span", { staticClass: "label label-success" }, [
                    _vm._v("Completed"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin && _vm.bookingIsNotPublic
                ? _c("span", { staticClass: "label label-hidden" }, [
                    _vm._v("Hidden"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$paymentsModuleEnabled && _vm.bookingBookedDepositUnpaid
                ? _c("span", { staticClass: "label label-danger" }, [
                    _vm._v("Deposit Unpaid"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$paymentsModuleEnabled && _vm.bookingBookedDepositSent
                ? _c("span", { staticClass: "label label-danger" }, [
                    _vm._v("Deposit Sent"),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-item__chat chat-item" },
              [
                _vm.thread.latest_message
                  ? _c(
                      "div",
                      {
                        staticClass: "chat-item__message",
                        class: {
                          "chat-item__message--unread":
                            this.thread.unread_count && _vm.$userIsAdmin,
                        },
                      },
                      [
                        _c("div", { staticClass: "chat-item__body" }, [
                          _vm._v(
                            _vm._s(
                              _vm.thread.latest_message.file
                                ? "File Uploaded"
                                : _vm.thread.latest_message.text
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-item__meta flex flex-wrap w-full items-baseline",
                          },
                          [
                            _c("div", { staticClass: "chat-item__name" }, [
                              _vm._v(_vm._s(_vm.messageName)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "chat-item__time" }, [
                              _vm._v(_vm._s(_vm.messageTimestamp)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : [_c("span", [_vm._v("No Messages")])],
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "list-item__values" }, [
          _vm.$costReferences
            ? _c(
                "div",
                { staticClass: "list-item__budget" },
                [
                  _vm.$userIsTalent ||
                  (_vm.$userIsManager && _vm.monetaryCurrency)
                    ? [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("nullable")(
                                _vm._f("currency")(
                                  _vm.booking.budget_per_star_as_user_rate,
                                  _vm.booking.currency
                                )
                              )
                            ) +
                            "\n          "
                        ),
                        _vm.$userIsManager
                          ? [
                              _vm._v(
                                "\n            / " +
                                  _vm._s(_vm.$starLabel) +
                                  "\n          "
                              ),
                            ]
                          : _vm._e(),
                      ]
                    : [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.booking.budget_per_star,
                                _vm.booking.currency
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.$userIsAdmin && _vm.monetaryCurrency
                          ? [
                              _vm._v(
                                "\n            (" +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.booking.budget_per_star_as_user_rate,
                                      _vm.booking.currency
                                    )
                                  ) +
                                  ")\n          "
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(
                          "\n          / " +
                            _vm._s(_vm.$starLabel) +
                            "\n        "
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$userIsAdmin
            ? _c(
                "div",
                {
                  staticClass:
                    "list-item__admin list-item__admin--left-aligned",
                },
                [
                  _vm.$paymentsModuleEnabled
                    ? [
                        _vm.bookingStateOrOnline
                          ? _c(
                              "meta-item",
                              {
                                attrs: {
                                  icon: "globe",
                                  label: false,
                                  "full-width": true,
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.bookingStateOrOnline) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.bookingAppearanceInPerson
                          ? _c(
                              "meta-item",
                              {
                                attrs: {
                                  icon: "calendar",
                                  label: false,
                                  "full-width": true,
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("nullable")(
                                        _vm._f("dateTimezone")(
                                          _vm.booking.tz_date,
                                          _vm.booking.timezone,
                                          _vm.$user.date_format_preference
                                        )
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _c(
                              "meta-item",
                              {
                                attrs: {
                                  icon: "calendar",
                                  label: false,
                                  "full-width": true,
                                },
                              },
                              [_vm._v("\n             –\n          ")]
                            ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bookingIsNotPublic
                    ? _c("meta-item", { attrs: { icon: "eye-slash" } }, [
                        _vm._v("Hidden"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "meta-item",
                    {
                      attrs: { "full-width": true },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "key",
                            fn: function () {
                              return [_vm._v("Booking ID:")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2678695764
                      ),
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.booking.id) + "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.booking.payments.length > 0
                    ? _vm._l(_vm.booking.payments, function (payment) {
                        return _c(
                          "meta-item",
                          {
                            key: payment.id,
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "key",
                                  fn: function () {
                                    return [_vm._v(_vm._s(payment.type) + ":")]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(payment.status) +
                                "\n          "
                            ),
                          ]
                        )
                      })
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.$userIsAdmin
      ? _c(
          "button",
          {
            staticClass: "list-item__pin",
            class: {
              "list-item__pin--pinned": _vm.thread.pinned,
            },
            on: { click: _vm.handlePinThreadCallback },
          },
          [_c("i", { staticClass: "fa fa-thumb-tack" })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }